import { withLocalState } from 'pyradux';

import PaymentsContainer from './Payments.container';
import reducer from './Payments.reducer';
import PaymentsSagas from './Payments.sagas';

const withLocalStateOptions = {
  reducer,
  stateKey: 'payments',
  sagas: [PaymentsSagas],
};

export default withLocalState(withLocalStateOptions, PaymentsContainer);



// WEBPACK FOOTER //
// ./src/app/modules/WorkArea/Payments/index.js